<mat-label class="subHeading">Maturity Age</mat-label>
<div formGroupName="maturity_age" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="2" type="text" class="w-50 m-0" placeholder="From">
    -
    <input formControlName="to" [maxlength]="2"  type="text" class="w-50 m-0" placeholder="To">
</div>